import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const isDefaultOperationSucceeded = (response: DefaultOperationSuccessResponse) => response?.data?.[0]?.success === true;

// Callers such as ExportModal expect a definite response, so a failed operation has to reject
export const ensureDefaultOperationResponse = (
  response: DefaultOperationSuccessResponse | undefined,
  errorMessage: string,
): DefaultOperationSuccessResponse => {
  if (!response) {
    throw new Error(errorMessage);
  }

  return response;
};
